<app-header [label]="page_name | plural"></app-header>

<!-- Toolbar -->
<div class="flex flex-wrap items-center justify-between gap-4 mb-4">
  <div class="flex items-center gap-4">
    <app-select-input label="School" class="w-44" [(ngModel)]="filter_university_id" [options]="dds.dropdown_list?.university_list" (ngModelChange)="on_university_filter_change($event)"></app-select-input>
    <app-select-input label="Academic Year" class="w-44" [(ngModel)]="filter_academic_year_id" [options]="dds.dropdown_list?.academic_list" (ngModelChange)="on_academic_year_filter_change()"></app-select-input>
    <app-select-input label="Exam Name" class="w-44" [(ngModel)]="filter_exam_id" [options]="(filter_university_id && filter_academic_year_id) ? (dds.dropdown_list?.exam_list | filterByKeyAndValue : 'university_id' : filter_university_id | filterByKeyAndValue : 'AcademicYear.id' : filter_academic_year_id) : filter_university_id ? (dds.dropdown_list?.exam_list | filterByKeyAndValue : 'university_id' : filter_university_id) : dds.dropdown_list?.exam_list" (ngModelChange)="on_exam_filter_change()"></app-select-input>
    <app-select-input label="Subject Name" class="w-44" [(ngModel)]="filter_subject_id" [options]="filter_exam_id ? (dds.dropdown_list?.assess_list | filterByKeyAndValue : 'exam_id' : filter_exam_id | filterByKeyAndValue : 'university_id' : filter_university_id | filterByKeyAndValue : 'academic_year_id' : filter_academic_year_id) : dds.dropdown_list?.subject_list" (ngModelChange)="on_filter_change()"></app-select-input>
  </div>

  <div class="flex gap-4 items-center w-auto">
    <app-search-input class="w-auto" #searchbar (valueChange)="on_search($event)"></app-search-input>
    <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="download_scripts()"></app-button>
    <app-button *ngIf="gs.user_role_data?.script_management_scripts_add" (click)="route.navigate(['/add-script/form'])" icon="bx bx-plus" color="bg-secondary text-[#310000]" [label]="page_name"></app-button>
  </div>
</div>

<!-- Table -->
<div class="bg-white grid grid-rows-[1fr_auto] h-[calc(100vh-200px)] min-h-[500px]">
  <div class="overflow-auto">
    <table class="w-full">
      <!-- Header -->
      <thead *ngIf="items?.data?.length">
        <tr class="border-b border-gray-200">
          <th class="px-4 py-4">
            <input type="checkbox" class="w-4 h-4 accent-primary cursor-pointer" [checked]="items?.data?.length && selected_rows.size === items?.data?.length" (change)="toggle_all($event)" />
          </th>
          <th class="text-left px-4 py-4 text-sm font-semibold text-primary">Scanned Date</th>
          <th class="text-left px-4 py-4 text-sm font-semibold text-primary">Total Pages</th>
          <th class="text-left px-4 py-4 text-sm font-semibold text-primary">Barcode</th>
          <th class="text-left px-4 py-4 text-sm font-semibold text-primary">AI Status</th>
          <th *ngFor="let ev of evaluator_columns; let i = index" class="text-left px-4 py-4 text-sm font-semibold text-primary">Evaluator {{ i + 1 }}</th>
          <th *ngIf="head_evaluator_columns.length" class="text-left px-4 py-4 text-sm font-semibold text-primary">Head Evaluator</th>
          <th class="text-center px-4 py-4 text-sm font-semibold text-primary">Evaluation Status</th>
          <th class="text-center px-4 py-4 text-sm font-semibold text-primary"></th>
        </tr>
      </thead>
      <!-- Rows -->
      <tbody>
        <tr *ngFor="let item of items?.data" class="border-b border-gray-100 hover:bg-gray-50 transition-colors" [class.bg-blue-50]="selected_rows.has(item.id)">
          <td class="px-4 py-4">
            <input type="checkbox" class="w-4 h-4 accent-primary cursor-pointer" [checked]="selected_rows.has(item.id)" (change)="toggle_row(item.id)" />
          </td>
          <td class="px-4 py-4 text-sm text-gray-700">{{ item.document_uploaded_date || '-' }}</td>
          <td class="px-4 py-4 text-sm text-gray-700">{{ item.ScriptImages?.length ?? item.no_of_pages_per_script ?? '-' }}</td>
          <td class="px-4 py-4 text-sm text-gray-700">{{ item.barcode || '-' }}</td>
          <td class="px-4 py-4 text-sm font-medium" [style.color]="item.ai_status === 'Completed' ? '#008A2E' : item.ai_status === 'Processing' ? '#D17E3F' : item.ai_status === 'Failed' ? '#DC2626' : '#9CA3AF'">
            {{ item.ai_status || '-' }}
          </td>
          <td *ngFor="let ev of evaluator_columns; let i = index" class="px-4 py-4 text-sm text-gray-700">{{ item['evaluator_' + (i + 1)]?.name || '-' }}</td>
          <td *ngIf="head_evaluator_columns.length" class="px-4 py-4 text-sm text-gray-700">{{ item.head_evaluator?.name || '-' }}</td>
          <td class="px-4 py-4 text-center">
            <ng-container *ngIf="item.is_exception_raised; else notException">
              <span class="inline-flex text-center items-center rounded-full text-sm font-medium" style="background-color:#FEE2E2; color:#991B1B; padding:8px 16px; gap:8px; height:44px; white-space:nowrap;">
                <i class="bx bx-alert-octagon text-lg flex-shrink-0 mt-1"></i> Exception Raised
              </span>
            </ng-container>
            <ng-template #notException>
              <ng-container *ngIf="is_last_level_completed(item); else pendingBadge">
                <span class="inline-flex items-center rounded-full text-sm font-medium w-36" style="background-color:#DCFCE7; color:#008A2E; padding:8px 16px; gap:24px; height:44px;">
                  <span class="w-2 h-2 rounded-full flex-shrink-0" style="background-color:#008A2E;"></span> Completed
                </span>
              </ng-container>
              <ng-template #pendingBadge>
                <span class="inline-flex items-center rounded-full text-sm font-medium w-36" style="background-color:#F8ECE2; color:#D17E3F; padding:8px 16px; gap:24px; height:44px;">
                  <span class="w-2 h-2 rounded-full flex-shrink-0" style="background-color:#D17E3F;"></span> Pending
                </span>
              </ng-template>
            </ng-template>
          </td>
          <td class="px-4 py-4">
            <div class="relative flex justify-center">
              <button type="button" (click)="toggle_menu(item.id, $event)" class="p-2 rounded-lg hover:bg-gray-100 text-gray-500">
                <i class="bx bx-dots-vertical-rounded text-xl"></i>
              </button>
              <div *ngIf="active_menu_id === item.id" class="absolute right-6 top-8 bg-white border border-gray-200 rounded-lg shadow-lg z-20 min-w-[150px]">
                <button *ngIf="gs.user_role_data?.script_management_scripts_view" type="button" (click)="open_view_modal(item); active_menu_id = null" class="w-full flex items-center gap-2 px-4 py-2.5 text-sm hover:bg-gray-50 text-gray-700">
                  <i class="bx bx-show text-primary text-lg"></i> View Script
                </button>
                <button *ngIf="(item.can_delete !== false) && gs.user_role_data?.script_management_scripts_delete" type="button" (click)="open_delete_modal(item, null); active_menu_id = null" class="w-full flex items-center gap-2 px-4 py-2.5 text-sm hover:bg-gray-50 text-red-500">
                  <i class="bx bx-trash text-lg"></i> Delete
                </button>
              </div>
            </div>
          </td>
        </tr>
        <!-- Empty state -->
        <tr *ngIf="!items?.data?.length">
          <td [attr.colspan]="5 + evaluator_columns.length + (head_evaluator_columns.length ? 1 : 0) + 2" class="h-[calc(100vh-350px)]">
            <div class="flex flex-col items-center justify-center h-full gap-2">
              <span class="text-2xl font-semibold text-gray-400">No Data Available</span>
              <span class="text-sm text-gray-400">Please select the dropdown options to view the scripts.</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="border-t border-gray-200 py-3 px-8 flex justify-between items-center">
    <div class="flex gap-4">
      <span class="text-sm border-r-2 pr-4 border-r-gray-300">Total {{ items?.count || 0 }}</span>
      <span class="text-sm">Showing {{ items?.data?.length || 0 }} items</span>
    </div>
    <div class="flex gap-4 items-center">
      <app-button *ngIf="selected_rows.size > 0" icon="bx bx-trash" (click)="open_bulk_delete_modal()"></app-button>
      <app-button [disabled]="pagination.page === 1" [ngClass]="{ 'opacity-50 cursor-not-allowed': pagination.page === 1 }" icon="bx bx-chevrons-left" (click)="change_pagination('first')"></app-button>
      <app-button [disabled]="pagination.page === 1" [ngClass]="{ 'opacity-50 cursor-not-allowed': pagination.page === 1 }" icon="bx bx-chevron-left" (click)="change_pagination('previous')"></app-button>
      <span class="text-sm">Page {{ pagination.page }} of {{ total_pages }}</span>
      <app-button [disabled]="pagination.page === total_pages || !items?.data?.length" [ngClass]="{ 'opacity-50 cursor-not-allowed': pagination.page === total_pages }" icon="bx bx-chevron-right" (click)="change_pagination('next')"></app-button>
      <app-button [disabled]="pagination.page === total_pages || !items?.data?.length" [ngClass]="{ 'opacity-50 cursor-not-allowed': pagination.page === total_pages }" icon="bx bx-chevrons-right" (click)="change_pagination('last')"></app-button>
      <app-button icon="bx bx-refresh" (click)="get_list()"></app-button>
    </div>
  </div>

</div>

<app-confirmation-popup #confirmation_disabled_modal [warning]="true" [enable_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" [show_cancel_icon]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  You cannot Disabled this record as it is already linked to other masters.
</app-confirmation-popup>
<app-confirmation-popup #confirmation_delete_modal [delete_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" [show_cancel_icon]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to Delete {{ selected_rows.size > 0 ? selected_rows.size + ' record(s)' : 'this record' }}?
</app-confirmation-popup>

<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
  <app-bulk-upload [cancel]="bulk_modal" [accepted_type]="['.csv']" [title]="page_name" [accepted_type]="'.csv'" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>

<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
  <div class="h-full overflow-auto">
    <div *ngFor="let item of script_images; let i = index" class="relative w-full mb-4">
      <div *ngIf="i >= supplement_start_index && supplement_start_index > 0" class="text-sm font-semibold text-gray-600 mb-2 px-2">
        Supplement Page {{ i - supplement_start_index + 1 }}
      </div>
      <img [src]="item" alt="Answer Script Image" class="w-full object-contain" />
      <!-- Blur overlay for script pages -->
      <div *ngIf="i < supplement_start_index && script_page_blur[i] > 0"
        class="absolute top-0 left-0 w-full backdrop-blur-[50px] pointer-events-none"
        [style.height.%]="script_page_blur[i]">
      </div>
      <!-- Blur overlay for supplement pages -->
      <div *ngIf="i >= supplement_start_index && supplement_page_blur[i - supplement_start_index] > 0"
        class="absolute top-0 left-0 w-full backdrop-blur-[50px] pointer-events-none"
        [style.height.%]="supplement_page_blur[i - supplement_start_index]">
      </div>
    </div>
  </div>
</app-modal>